export const StepWrapper = ({
  children,
  title,
  description,
  withBackground = true,
  maxWidth = "max-w-[90vw] md:max-w-[70vw]",
}) => (
  <div className="flex flex-col items-center justify-start md:justify-center w-full min-h-full">
    <h3
      className="text-center mb-2 text-3xl font-semibold text-white"
      data-testid={`step-title-${title}`}
    >
      {title}
    </h3>
    <h5
      className={`text-center mb-8 text-base md:text-lg mx-auto text-white font-medium ${maxWidth} backdrop-blur-xs rounded-full`}
    >
      {description}
    </h5>

    <div
      className={`${
        withBackground &&
        "bg-white/10 rounded-xl p-8 border border-white/20 shadow-lg backdrop-blur-xs"
      } w-full ${maxWidth}`}
    >
      {children}
    </div>
  </div>
);

export default StepWrapper;
